type ToastFn = (message: string) => void;

let _error: ToastFn | null = null;
let _warning: ToastFn | null = null;

const _lastShown: Record<string, number> = {};
const DEBOUNCE_MS = 4000;

function canShow(key: string): boolean {
  const now = Date.now();
  if (now - (_lastShown[key] ?? 0) < DEBOUNCE_MS) return false;
  _lastShown[key] = now;
  return true;
}

export const toastBridge = {
  register(error: ToastFn, warning: ToastFn): void {
    _error = error;
    _warning = warning;
  },
  error(message: string, key = message): void {
    if (canShow(key)) _error?.(message);
  },
  warning(message: string, key = message): void {
    if (canShow(key)) _warning?.(message);
  },
};
